export default "__VITE_ASSET__CKwe4Vvi__"